import { render, staticRenderFns } from "./ShipmentPage.vue?vue&type=template&id=f76e2004&scoped=true"
import script from "./ShipmentPage.vue?vue&type=script&lang=js"
export * from "./ShipmentPage.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPage.vue?vue&type=style&index=0&id=f76e2004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76e2004",
  null
  
)

export default component.exports